import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-700" }
const _hoisted_2 = { class: "container mx-auto flex flex-col sm:flex-row justify-between items-center text-3xl border-b border-gray-400 mb-20 py-12 px-4 sm:px-0" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"space-y-2 mr-0 sm:mr-64 mb-8 sm:mb-0\"><h1 class=\"font-body text-white\">Budget Template</h1><p class=\"text-base font-header text-gray-500\"> Add all your monthly expenses here! Whenever you create a new budget, the expenses here will automatically show in your new monthly budget. The idea is to not to manually enter the same info more than once. </p><p class=\"text-base font-header text-gray-500\"> All you have to do is click on the &#39;Add Expense&#39; button, select the type of expense, enter the details and save your changes. </p><p class=\"text-base font-header text-gray-500\"> If you were to delete an item on this page, all already existing budgets will be unaffected. </p></div>", 1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Save", -1)
const _hoisted_5 = { class: "container mx-auto relative" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")
  const _component_ExpenseModal = _resolveComponent("ExpenseModal")
  const _component_ExpenseSlideover = _resolveComponent("ExpenseSlideover")
  const _component_SaveIcon = _resolveComponent("SaveIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_Alert = _resolveComponent("Alert")
  const _component_BudgetTemplateTable = _resolveComponent("BudgetTemplateTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationModal, {
      title: "Remove Expense",
      text: "Are you sure you want to remove this expense?",
      show: _ctx.showConfirmModal,
      "onUpdate:show": _cache[1] || (_cache[1] = $event => (_ctx.showConfirmModal = $event)),
      onConfirm: _cache[2] || (_cache[2] = $event => (_ctx.confirmRemoveExpense()))
    }, null, 8, ["show"]),
    _createVNode(_component_ExpenseModal, {
      class: "hidden lg:block",
      show: _ctx.showModal,
      "onUpdate:show": _cache[3] || (_cache[3] = $event => (_ctx.showModal = $event)),
      data: _ctx.expenseData,
      type: _ctx.selectedCategory,
      "hide-sidebar": "",
      "onUpdate-budget": _cache[4] || (_cache[4] = $event => (_ctx.updateLocalExpense($event)))
    }, null, 8, ["show", "data", "type"]),
    _createVNode(_component_ExpenseSlideover, {
      class: "block lg:hidden",
      show: _ctx.showModal,
      "onUpdate:show": _cache[5] || (_cache[5] = $event => (_ctx.showModal = $event)),
      data: _ctx.expenseData,
      type: _ctx.selectedCategory,
      "hide-sidebar": "",
      "onUpdate-budget": _cache[6] || (_cache[6] = $event => (_ctx.updateLocalExpense($event)))
    }, null, 8, ["show", "data", "type"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Button, {
          color: "primary",
          class: "w-full sm:w-auto",
          "is-disabled": _ctx.disableSave,
          onClick: _cache[7] || (_cache[7] = $event => (_ctx.saveBudgetTemplate()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SaveIcon, { class: "w-5 h-5 mr-2" }),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["is-disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (!_ctx.alert.hide)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["absolute w-full top-0 left-0 transform transition duration-200 ease-in-out", {
				'-translate-y-12 opacity-100': _ctx.alert.show,
				'-translate-y-24 opacity-0': !_ctx.alert.show,
			}]
          }, [
            _createVNode(_component_Alert, {
              type: _ctx.alert.type,
              message: _ctx.alert.message
            }, null, 8, ["type", "message"])
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.expenses, (item, key) => {
        return (_openBlock(), _createBlock(_component_BudgetTemplateTable, {
          key: key,
          category: key,
          data: item,
          "onAdd-expense": _cache[8] || (_cache[8] = $event => (_ctx.openExpense($event))),
          "onShow-remove-expense-modal": _cache[9] || (_cache[9] = $event => (_ctx.setDeleteAndShowConfirmation($event)))
        }, null, 8, ["category", "data"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}